<template>
  <b-modal
    :id="modalId"
    ref="modalInsufficientCredit"
    centered
    hide-header
    hide-footer
    no-close-on-backdrop
    body-class="p-0"
    dialog-class="custom-width-modal"
  >
    <div class="komed-modal-container">
      <!-- Icon -->
      <div class="komed-modal-icon-wrapper">
        <img
          src="@/assets/images/icons/fail.svg"
          alt="Error"
          width="100"
          height="100"
          @error="handleImageError"
        >
      </div>

      <!-- Text -->
      <h4 class="komed-modal-title">
        Generate Video Gagal, Kredit Tidak Mencukupi
      </h4>
      <p class="komed-modal-subtitle">
        Gagal generate video karena kredit yang kamu miliki tidak mencukupi. Top up terlebih dahulu untuk melanjutkan.
      </p>

      <!-- Actions -->
      <div class="komed-modal-actions">
        <b-button
          block
          class="komed-btn-cancel"
          @click="handleClose"
        >
          Batal
        </b-button>
        <b-button
          block
          class="komed-btn-primary"
          @click="handleTopup"
        >
          Top Up
        </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  props: {
    modalId: {
      type: String,
      required: true,
    },
  },
  methods: {
    handleClose() {
      this.$bvModal.hide(this.modalId)
      this.$emit('close')
    },
    handleTopup() {
      this.handleClose()
      this.$emit('topup')
    },
    handleImageError(e) {
      // Fallback if the error.svg doesn't exist on Komerce storage
      e.target.outerHTML = `<svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="50" cy="50" r="40" fill="#FF4D4F"/>
        <path d="M60 40L40 60M40 40L60 60" stroke="white" stroke-width="8" stroke-linecap="round"/>
      </svg>`
    },
  },
}
</script>

<style scoped>
::v-deep .custom-width-modal .modal-dialog {
  max-width: 440px;
  border-radius: 24px;
}
::v-deep .custom-width-modal .modal-content {
  border-radius: 24px;
  border: none;
}
.komed-modal-container {
  background: white;
  border-radius: 24px;
  padding: 32px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.komed-modal-icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
}
.komed-modal-title {
  text-align: center;
  font-weight: 600;
  font-size: 20px;
  color: #1f1f1f;
  margin-bottom: 8px;
  margin-top: 0;
}
.komed-modal-subtitle {
  text-align: center;
  color: #8c8c8c;
  font-size: 14px;
  margin-bottom: 32px;
  margin-top: 0;
  line-height: 1.5;
}
.komed-modal-actions {
  display: flex;
  width: 100%;
  gap: 16px;
}
.komed-btn-cancel {
  flex: 1;
  height: 48px;
  border-radius: 16px;
  font-weight: 500;
  color: #1f1f1f !important;
  background: white !important;
  border: 1px solid #ece7e2 !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08) !important;
  margin: 0;
}
.komed-btn-primary {
  flex: 1;
  height: 48px;
  border-radius: 16px;
  font-weight: 500;
  color: white !important;
  background: #ff6a13 !important;
  border: none !important;
  margin: 0;
}
.komed-btn-primary:hover {
  background: #ff7d32 !important;
}
</style>
